import { loadable } from 'utils';

export const Approval = loadable(() => import('./Approval'), {});
export const Basic = loadable(() => import('./Basic'), {});
export const Import = loadable(() => import('./Import'), {});
export const Manual = loadable(() => import('./Manual'), {});
